import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { PixKeyConfirmation } from '../PixKeyConfirmation';
import { PixKeyInput } from '../PixKeyInput';
import { PixKeyTypeSelector } from '../PixKeyTypeSelector';
import styles from './PixKeyCreation.module.css';
export function PixKeyCreationStepContent({ dataTestId, stepContent, userTaxIdentifier, pixKeys, }) {
    const { t } = useTranslation();
    const renderContent = () => {
        switch (stepContent.type) {
            case 'typeSelector':
                return (_jsx(PixKeyTypeSelector, { dataTestId: `${dataTestId}Step1`, onKeyTypeSelect: stepContent.props.onKeyTypeSelect, pixKeys: pixKeys }));
            case 'input':
                return (_jsx(PixKeyInput, { dataTestId: `${dataTestId}Step2`, selectedKeyType: stepContent.props.selectedKeyType, value: stepContent.props.keyValue ?? '', onChange: stepContent.props.onKeyValueChange, onValidationChange: stepContent.props.onValidationChange, onInputTouched: stepContent.props.onInputTouched, userTaxIdentifier: userTaxIdentifier }));
            case 'confirmation':
                return (_jsx(PixKeyConfirmation, { dataTestId: `${dataTestId}Step3`, keyType: stepContent.props.keyType, keyValue: stepContent.props.keyValue, onConfirm: stepContent.props.onConfirm, onResend: stepContent.props.onResend, disabled: stepContent.props.disabled, loading: stepContent.props.loading, error: stepContent.props.error, verificationCode: stepContent.props.verificationCode, onVerificationCodeChange: stepContent.props.onVerificationCodeChange }));
            case 'placeholder':
            default:
                return (_jsx("div", { className: styles.placeholderContent, children: _jsx("p", { children: t(stepContent.props.message) }) }));
        }
    };
    return _jsx(_Fragment, { children: renderContent() });
}
